import { render } from "./DeleteComponent.vue?vue&type=template&id=36dd0f0a"
import script from "./DeleteComponent.vue?vue&type=script&lang=js"
export * from "./DeleteComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__